import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

export const PasswordSent = () => {
  const navigate = useNavigate();
  const handleMove = () => navigate('/reset-password');
  const { t } = useTranslation();
  return (
    <div className="p-7 w-96 flex flex-col items-center py-6 h-48 justify-center">
      <span className="text-lg font-medium mb-2">
        {t('auth.check_email_text')}
      </span>
      <p className="text-base text-center" onClick={handleMove}>
        {t('auth.check_email_desc')}
      </p>
    </div>
  );
};
